import React, { PropsWithChildren } from 'react';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import MinimizeIcon from '@material-ui/icons/Minimize'
import Typography from '@material-ui/core/Typography';
import { useAppState } from '../../../state';
import { Paper, PaperProps } from '@material-ui/core';
import Draggable from 'react-draggable';
import ChatKendo from '../ChatDialog/ChatKendo';

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other} style={{ cursor: 'move' }}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <MinimizeIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

interface ChatDialogProps {
    open: boolean;
    onClose(): void;
}
function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}


export default function ChatDialog({ open, onClose }: PropsWithChildren<ChatDialogProps>) {
    const { guestName, meetingNum, meetingTitle, guestToken } = useAppState();
    //const [collapse, setCollapse] = React.useState(true);
    /*
    const handleClick = () => {
        setCollapse(!collapse);
    };*/

    return (
        <div>
            <Dialog onClose={onClose} aria-labelledby="VoiceSync Chat" open={open} disableEnforceFocus PaperComponent={PaperComponent}>
                <DialogTitle id="draggable-dialog-title" onClose={onClose} >
                    Chat: {meetingTitle}
                </DialogTitle>

                <DialogContent dividers>
                    <ChatKendo username={guestName} roomNum={meetingNum} token={guestToken} meetingNum={meetingNum} />
                </DialogContent>
            </Dialog>
        </div>
    );
}